import React, { PropsWithChildren, useContext } from "react";

const PopoverContext = React.createContext<boolean | undefined>(undefined);
PopoverContext.displayName = "Popover";

export function PopoverProvider({ children }: PropsWithChildren) {
  return <PopoverContext.Provider value>{children}</PopoverContext.Provider>;
}

export function usePopoverContext(): boolean {
  return !!useContext(PopoverContext);
}
